import { memo } from 'react'
import { Button } from '@mui/material'
import SettingsOutlinedIcon from '../../assets/icons/SettingOutlined'

type Props = {
    width: number
    onClick: () => void
}

const settingsButtonSx = {
    right: '0px',
    position: 'absolute',
    alignItems: 'center',
    minWidth: '40px',
    bottom: '0px',
    zIndex: 9,
} as const

const PayoffSettingsButton = memo(
    ({ width, onClick }: Props) => (
        <span title="Payoff Settings" style={{ position: 'absolute', right: 0, bottom: 0, zIndex: 9, lineHeight: 0 }}>
            <Button
                variant="text"
                color="inherit"
                onClick={onClick}
                sx={{ ...settingsButtonSx, width }}
            >
                <SettingsOutlinedIcon sx={{ width: 20, height: 20 }} />
            </Button>
        </span>
    ),
    (prev, next) => prev.width === next.width && prev.onClick === next.onClick
)

export default PayoffSettingsButton
